var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgComparisonCross = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 10",
  preserveAspectRatio: "xMidYMid meet"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m4.575 5.95-2.9 2.9a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275.95.95 0 0 1-.275-.7q0-.425.275-.7l2.9-2.9-2.9-2.875A.95.95 0 0 1 0 .975q0-.425.275-.7A.95.95 0 0 1 .975 0q.425 0 .7.275l2.9 2.9L7.45.275A.95.95 0 0 1 8.15 0q.425 0 .7.275.3.3.3.713 0 .412-.3.687L5.95 4.55l2.9 2.9a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7q-.3.3-.713.3a.9.9 0 0 1-.687-.3z"
})));
export default SvgComparisonCross;